var audio_rtlignore_default = {
  "fontElementMap": "LDXx1",
  "customPlayer": "NMjFX",
  "customPlayer_basic": "W3OER",
  "customPlayer_mobile": "XCE0X",
  "audio_coverImg": "fDiiI",
  "audio_small_cover_image": "Ox84k",
  "audio_icon_button": "etj6e",
  "audio_contextMenu_wrapper": "sfnF6",
  "customPlayer_with_image": "OoRFx",
  "track_wrapper": "ih5fs",
  "trackContainer": "Agoci",
  "audio_download_icon": "oyCU5",
  "audio_duration": "xYX9v",
  "customPlayer_small_fit": "bQKTE",
  "track_sliders_wrapper": "NM7Q5",
  "audio_volume_wrapper": "_8rzsD",
  "volume_slider_wrapper": "_3lX3c",
  "audioDetails": "KYpII",
  "title": "vk0YP",
  "author_name": "_5nLcX",
  "dropdown_menu_wrapper": "s7O-c",
  "dropdown_selected_button": "BcoE8",
  "dropdown_content": "aTPzA",
  "dropdown_content_withIcon": "G5O2b",
  "audio_loader_icon": "_-7KTw",
  "spin": "OfsT2"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
